var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"blockchain-item"},[_c('span',{staticClass:"blockchain-icon",class:_vm.supportedWallet.name},[_c('img',{staticClass:"svg",attrs:{"src":require("../../../public/images/blockchainBorder.svg"),"width":"70","height":"90","alt":"border"}})]),_vm._v(" "+_vm._s(_vm.supportedWallet.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }